import { render, staticRenderFns } from "./CatalystDetail.vue?vue&type=template&id=cc9f729e&"
import script from "./CatalystDetail.vue?vue&type=script&lang=js&"
export * from "./CatalystDetail.vue?vue&type=script&lang=js&"
import style0 from "./CatalystDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports